import Icon from "@react-native-vector-icons/material-design-icons/static";
import { Text, TouchableOpacity } from "react-native";
import { useAppTheme } from "../../useAppTheme";
import WaveformSvg from "../AssistantApplet/waveform.svg";
import Box from "../Box";

export type VoiceChatFeedbackProps = {
	title: string;
	description: string;
	onThumbUpPress: () => void;
	onThumbDownPress: () => void;
};

const VoiceChatFeedback = ({
	title,
	description,
	onThumbUpPress,
	onThumbDownPress,
}: VoiceChatFeedbackProps) => {
	const theme = useAppTheme();

	return (
		<>
			<Box
				width={368}
				paddingLeft={16}
				paddingRight={8}
				gap={8}
				flexDirection="row"
				borderWidth={1}
				borderRadius={12}
				borderColor={theme.colors.outlineVariant}
				alignItems="center"
			>
				<WaveformSvg width={24} height={24} />
				<Box paddingVertical={12} paddingHorizontal={8}>
					<Text style={{ color: theme.colors.onSurfaceVariant }}>{title}</Text>
					<Text style={{ color: theme.colors.onSurfaceVariant }}>
						{description}
					</Text>
				</Box>
				<Box
					flex={1}
					flexDirection="row"
					gap={4}
					alignItems="center"
					justifyContent="flex-end"
					paddingRight={8}
				>
					<TouchableOpacity
						onPress={onThumbUpPress}
						style={{
							width: 48,
							height: 48,
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Icon
							name="thumb-up-outline"
							size={24}
							color={theme.colors.onSurfaceVariant}
						/>
					</TouchableOpacity>
					<TouchableOpacity
						onPress={onThumbDownPress}
						style={{
							width: 48,
							height: 48,
							alignItems: "center",
							justifyContent: "center",
						}}
					>
						<Icon
							name="thumb-down-outline"
							size={24}
							color={theme.colors.onSurfaceVariant}
						/>
					</TouchableOpacity>
				</Box>
			</Box>
		</>
	);
};

export default VoiceChatFeedback;
